module.exports = __webpack_public_path__ + "static/media/7.af483b9c.png";